import { render, staticRenderFns } from "./ComponentCheckpointType.vue?vue&type=template&id=8ed24286&"
import script from "./ComponentCheckpointType.vue?vue&type=script&lang=ts&"
export * from "./ComponentCheckpointType.vue?vue&type=script&lang=ts&"
import style0 from "./ComponentCheckpointType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
